import { render } from "./ListeModeLivraison.vue?vue&type=template&id=04c6d204&ts=true"
import script from "./ListeModeLivraison.vue?vue&type=script&lang=ts"
export * from "./ListeModeLivraison.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__